"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeFilter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Filter_1 = require("./filter/Filter");
const Filters_style_1 = require("./Filters.style");
const Filter_style_1 = require("./filter/Filter.style");
const offer_filter_context_1 = require("../../offer-filter-context");
const TypeFilter = ({ typeFilterItems, loading }) => {
    const intl = (0, react_intl_1.useIntl)();
    const { typeFiltersSelected, setTypeFiltersSelected } = (0, offer_filter_context_1.useOffersFilterContextValue)();
    const [isOpen, setIsOpen] = react_1.default.useState(false);
    const areCurrentFiltersNotEmpty = Boolean(typeFiltersSelected && typeFiltersSelected.length !== 0);
    const defaultTypeFiltersShownNum = 6;
    const toggleOfferType = (id) => {
        let newSelectedTypesIds = [];
        if (typeFiltersSelected.includes(id)) {
            newSelectedTypesIds = typeFiltersSelected.filter(typeId => typeId !== id);
        }
        else {
            newSelectedTypesIds = [...typeFiltersSelected, id];
        }
        setTypeFiltersSelected(newSelectedTypesIds);
    };
    const typeFilters = react_1.default.useMemo(() => typeFilterItems
        .map(filter => ({
        ...filter,
        isDisabled: filter.count === 0,
    }))
        .sort((a, b) => {
        if (a.translationKey && b.translationKey) {
            return intl
                .formatMessage({ id: `${a.translationKey}` })
                .localeCompare(intl.formatMessage({ id: `${b.translationKey}` }));
        }
        return a.name.localeCompare(b.name);
    })
        .sort((a, b) => {
        if (a.isDisabled && !b.isDisabled) {
            return 1;
        }
        if (!a.isDisabled && b.isDisabled) {
            return -1;
        }
        return 0;
    })
        .slice(0, isOpen ? typeFilterItems.length : defaultTypeFiltersShownNum), [intl, typeFilterItems, isOpen]);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Filter_style_1.FilterTitle, { noMargin: true, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offers.filter.type" }) }), (0, jsx_runtime_1.jsx)(Filter_style_1.FilterSeparator, {}), (0, jsx_runtime_1.jsxs)("div", { className: "m-b-l font-size-m", children: [typeFilters.map(filterItem => ((0, jsx_runtime_1.jsx)(Filter_1.Filter, { filterItem: filterItem, loading: loading, areCurrentFiltersNotEmpty: areCurrentFiltersNotEmpty, isSelected: typeFiltersSelected.includes(filterItem.id), isDisabled: filterItem.isDisabled, toggleFilter: toggleOfferType }, filterItem.id))), typeFilterItems.length > defaultTypeFiltersShownNum && ((0, jsx_runtime_1.jsxs)(Filters_style_1.ToggleFilterContentButton, { onClick: () => setIsOpen(!isOpen), type: "button", children: [isOpen && (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.hide_more_options" }), !isOpen && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.see_more_options" }), ` (${typeFilterItems.length - defaultTypeFiltersShownNum})`] }))] }))] })] }));
};
exports.TypeFilter = TypeFilter;
